import type { GlobalStateCommandFactory } from 'components/GlobalState/GlobalStateModel';
import { probeApiShared } from 'utils/request/systemUnavailable';
import { setSystemUnavailable } from './setSystemUnavailable';

/**
 * Report a response that looks like an outage. Resolves once the outage is confirmed or refuted,
 * so that the caller can throw its error afterwards and error handling sees the resolved state.
 *
 * Such a response alone is not enough, e.g. nginx returns 504 for a single slow request while
 * the API server is fine. Therefore the outage is confirmed by probing the API first.
 */
export const reportSuspectedOutage: GlobalStateCommandFactory =
  (cmdContext, dispatch) => async () => {
    if (cmdContext.getState().systemUnavailable) {
      return;
    }
    const result = await probeApiShared();
    if (!result.available) {
      dispatch(setSystemUnavailable, { value: true });
    }
  };
